<template>
	<div class="col-sm-3">
		<div class="box box-success">
			<div class="box-header with-border">
				<h3 class="box-title">
					<i class="fa fa-magic"></i>
					Campos
				</h3>
				<div class="pull-right box-tools">
					<button
						v-if="!$parent.open"
						type="button"
						class="btn btn-success btn-sm"
						:disabled="
							!id ||
							$parent.input.id == '' ||
							($parent.chForm.abas.list.length > 0 &&
								$parent.input.aba == '')
						"
						@click="$parent.addInput"
					>
						<i class="fa fa-plus"></i>
					</button>
					<button
						v-if="$parent.open"
						type="button"
						class="btn btn-primary btn-sm"
						@click="$parent.updateObj"
					>
						<i class="fa fa-check"></i>
					</button>
				</div>
			</div>
			<div v-if="!$parent.listAllInputs">
				<div class="box-body">
					<div class="row">
						<div class="col-sm-12">
							<span>Rótulo</span>
							<input
								@keyup="$parent.setId"
								v-model="$parent.input.label"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-8">
							<span>Tipo</span>
							<select
								v-model="$parent.input.type"
								class="form-control"
							>
								<option value="number">Númerico</option>
								<option value="text">Texto</option>
								<option value="date">Data</option>
								<option value="textarea">Área de texto</option>
								<option value="mask">Campo com mascará</option>
								<option value="password">Campo de senha</option>

								<option value="select">Campo de seleção</option>
								<option value="checkbox">
									Caixa de seleção
								</option>
								<option value="radio">Caixa de opção</option>

								<option value="table">Tabela</option>
								<option value="msg">Mensagem</option>
							</select>
						</div>
						<div class="col-sm-4">
							<span>Peso</span>
							<select
								v-model="$parent.input.order"
								class="form-control"
							>
								<option
									v-for="(num, index) in 10"
									:key="index"
									:value="num"
								>
									{{ num }}
								</option>
							</select>
						</div>

						<div class="col-sm-6">
							<span>Comp. </span>
							<select
								v-model="$parent.input.col"
								class="form-control"
							>
								<option
									v-for="(num, index) in 12"
									:key="index"
									:value="num"
								>
									{{ num }}
								</option>
							</select>
						</div>

						<div class="col-sm-6">
							<span>Altura</span>
							<select
								v-model="$parent.input.qntRows"
								:disabled="$parent.input.type != 'textarea'"
								class="form-control"
							>
								<option
									v-for="(num, index) in 15"
									:key="index"
									:value="num"
								>
									{{ num }}
								</option>
							</select>
						</div>

						<div
							class="col-sm-12"
							v-if="
								$parent.input.type != 'select' &&
								$parent.input.type != 'checkbox' &&
								$parent.input.type != 'radio' &&
								$parent.input.type != 'table'
							"
						>
							<span>Informação</span>
							<input
								v-model="$parent.input.placeholder"
								:disabled="$parent.input.type == 'date'"
								type="text"
								class="form-control"
							/>
						</div>

						<div
							class="col-sm-12"
							v-if="$parent.input.type == 'mask'"
						>
							<span>Mascara</span>
							<input
								v-model="$parent.input.mask"
								placeholder="CPF : ###.###.###-##"
								type="text"
								class="form-control"
							/>
						</div>

						<div
							class="col-sm-12"
							v-if="$parent.isOptCamp($parent.input.type)"
						>
							<span>Opções</span>
							<div class="input-group input-group-sm">
								<input
									type="text"
									disabled
									:value="$parent.optionsValue"
									class="form-control"
								/>
								<span class="input-group-btn">
									<button
										class="btn btn-warning"
										@click="
											$parent.openMdOptions($parent.input)
										"
									>
										<i class="fa fa-edit"></i>
									</button>
								</span>
							</div>
						</div>

						<div
							class="col-sm-12"
							v-if="
								$parent.input.type == 'checkbox' ||
								$parent.input.type == 'radio'
							"
						>
							<span>Alinhamento</span>
							<select
								v-model="$parent.input.options.aling"
								class="form-control"
							>
								<option value="">A baixo</option>
								<option value="-inline">Ao lado</option>
							</select>
						</div>

						<div
							class="col-sm-12"
							v-if="$parent.chForm.abas.list.length > 0"
						>
							<span>Aba</span>
							<select
								v-model="$parent.input.aba"
								class="form-control"
							>
								<option value="">Escolher</option>
								<option
									v-for="aba in $parent.chForm.abas.list"
									:value="aba.id"
								>
									{{ aba.titulo }}
								</option>
							</select>
						</div>

						<div
							class="col-sm-12"
							v-if="$parent.input.type != 'msg'"
						>
							<div class="checkbox">
								<label>
									<input
										type="checkbox"
										v-model="$parent.input.disabled"
									/>
									Desabilitado
								</label>
							</div>
						</div>

						<div
							class="col-sm-12"
							v-if="$parent.input.type == 'msg'"
						>
							<span>Tipo da mensagem</span>
							<select
								v-model="$parent.input.alert_type"
								class="form-control"
							>
								<option value="alert-success">Sucesso</option>
								<option value="alert-info">Informação</option>
								<option value="alert-warning">Atenção</option>
								<option value="alert-danger">Perigo</option>
							</select>
						</div>

						<div class="col-sm-12">
							<br />
							<button
								class="btn btn-link btn-xs btn-block"
								@click="$parent.listAllInputs = true"
							>
								<i class="fa fa-list"></i>
								Ver todos os campos
							</button>
						</div>
					</div>
				</div>

				<div class="well well-sm" style="margin-bottom: 0px">
					<div class="row">
						<div
							class="col-sm-12"
							:class="{ 'has-error': !id, 'has-success': id }"
						>
							<b>Identificação</b>
							<input
								v-model="$parent.input.id"
								maxlength="24"
								type="text"
								class="form-control"
							/>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12">
							<b>Valor inicial</b>
							<div class="input-group input-group-sm">
								<input
									:value="
										$parent.getValue($parent.input.value)
									"
									disabled
									type="text"
									class="form-control"
								/>
								<span class="input-group-btn">
									<button
										class="btn btn-warning"
										@click="$parent.input.value = ''"
										title="Resetar"
									>
										<i class="fa fa-trash-o"></i>
									</button>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="box-footer" v-if="$parent.open">
					<div class="row">
						<div class="col-sm-12">
							<button
								class="btn btn-danger btn-block"
								@click="$parent.deleteCamp()"
							>
								<i class="fa fa-trash"></i>
								Apagar campo
							</button>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="box-body">
					<div class="list-group">
						<a
							v-for="(inp, id) in $parent.chForm.inputs"
							class="list-group-item"
							@click="$parent.opInp({ id: id, data: inp })"
							:class="$parent.id == $parent.slid ? 'active' : ''"
						>
							<b class="val1">{{ $parent.inp.label }}</b>
							<i class="val2">
								{{ $parent.inp.type }}
								<div class="pull-right">
									<b>{{ $parent.getNameAba(inp.aba) }}</b>
								</div>
							</i>
						</a>
					</div>

					<ul
						v-if="$parent.chForm.inputs.length == 0"
						class="list-group"
					>
						<li class="list-group-item list-group-item-warning">
							Nenhum campo ainda!
						</li>
					</ul>
				</div>
				<div class="box-footer">
					<button
						class="btn btn-default btn-block"
						@click="$parent.listAllInputs = false"
					>
						<i class="fa fa-chevron-left"></i>
						Voltar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	export default {
		data() {
			return {
				list: [],
				id: true,
				oldId: '',
			};
		},
		watch: {
			oldId: function (val) {
				console.log(val);
				setTimeout((e) => {
					if (this.$parent.input.id == val) this.id = true;
				}, 100);
			},
			'$parent.input.id': function (val, old) {
				if (val != '') {
					let index = this.list.findIndex((item) => item == val);
					if (index == -1) this.id = true;
					else if (this.oldId == val) this.id = true;
					else this.id = false;
				} else {
					this.id = false;
				}
			},
		},
		mounted() {
			if (this.$parent.input.id == '') this.id = false;
			WBS.send('protected-custom-replaceDocument:getIndex', (resp) => {
				if (resp.status == 'success' && resp.data != undefined) {
					for (let index in resp.data) {
						this.list.push(index);
					}
					// this.list = resp.data
				}
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/create-form/components/settings-inputs.vue